export type KeyHintProps = {
  keys: string[];
  pressed?: boolean;
};

/**
 * Inline keycap showing a shortcut. Always rendered as a single visible
 * group of caps separated by a thin "+" — the consumer hands in the
 * individual keys and we own the visual spacing.
 */
export function KeyHint({ keys, pressed = false }: KeyHintProps) {
  const label = keys.join(' then ');
  return (
    <kbd
      aria-label={label}
      className="inline-flex items-center gap-sp-1 align-middle text-fs-meta text-gray-900"
    >
      {keys.map((k, i) => (
        <span key={`${k}-${i}`} className="inline-flex items-center gap-sp-1">
          {i > 0 ? <span aria-hidden className="text-gray-700">+</span> : null}
          <span
            className={
              'inline-block min-w-[1.4em] rounded-r-chip border px-sp-1 text-center font-mono ' +
              (pressed
                ? 'border-gray-500 bg-gray-300 text-gray-900'
                : 'border-gray-300 bg-gray-100 text-gray-900')
            }
          >
            {k}
          </span>
        </span>
      ))}
    </kbd>
  );
}
